<template>
  <section class="seed-box">
    <!--    <div class="blex bg-black w-full pt-120 lg:py-200 relative h-220-screen lg:h-200-screen">-->
    <div class="blex bg-black w-full pt-120 lg:py-200 relative">

      <!-- bg line   -->
      <div class="absolute top-0 z-1">
        <img src="@/assets/images/pages/main/seedBox/seedLine.svg" alt="" class="bg-line">
      </div>

      <!-- seedbox description   -->
      <div class="blex px-16 lg:px-0 w-full z-1">

        <!--  blur       -->
        <div class="seed-gradient">
          <img src="@/assets/images/pages/main/seedBox/greenGradient.svg" class="blex w-full">
        </div>

        <!--  seedbox image      -->
        <div class="z-5">
          <img src="@/assets/images/pages/main/seedBox/seedBox.svg" class="seed-box">
        </div>

        <div class="text-white font-bold text-2xl lg:text-6xl blex pt-20 lg:pt-100 pb-40 w-full z-5">
          SEEDBOX
        </div>
        <div class="text-white font-medium text-center text-2xs lg:text-base leading-xs z-5">
          {{ $t('seedBox.1') }}<br class="block lg:hidden">
          {{ $t('seedBox.2') }}
          <br><br class="block lg:hidden">
          {{ $t('seedBox.3') }}<br class="block lg:hidden">
          {{ $t('seedBox.4') }}<br class="block lg:hidden">
          {{ $t('seedBox.5') }}
        </div>

      </div>

      <!-- chart image   -->
      <div class="z-1 px-16 lg:px-0 py-40 lg:py-80 w-full lg:w-2/3 blex">
        <div class="w-full lg:w-1/2 mb-40 lg:mb-0">
          <img
              :src="$store.state.windowWidth > 1024 ? require('@/assets/images/pages/main/seedBox/chart.png') : require('@/assets/images/pages/main/seedBox/mChart.png')"
              alt="" class="blex w-full">
        </div>
        <div class="w-full lg:w-2/5 blex ml-0 lg:ml-40">
          <div class="font-medium text-white text-2xs lg:text-base leading-sm w-full pb-20">
            {{ $t('seedBox.6') }}
          </div>
          <div class="font-medium text-white text-2xs lg:text-base leading-sm w-full pb-20"
          >
            {{ $t('seedBox.7') }}
          </div>
          <div class="font-medium text-2xs lg:text-base text-white leading-sm w-full pb-20"
          >
            {{ $t('seedBox.8') }}
          </div>
          <div class="font-medium text-2xs lg:text-base text-white leading-sm w-full"
          >
            {{ $t('seedBox.9') }}
          </div>
        </div>
      </div>

      <!-- description   -->
      <div class="blex w-full px-16 lg:w-3/5">

        <div class="w-full blex py-20 lg:pb-40 lg:pt-0 items-start">
          <div class="blex-left items-start w-1/3 pr-6 lg:pr-0">
            <div class="text-white font-semiBold text-base lg:text-xl w-full pb-10"
            >
              {{ $t('seedBox.10') }}
            </div>
            <div class="text-gray font-medium text-2xs lg:text-xs leading-xs"
            >
              {{ $t('seedBox.11') }}<br class="hidden lg:block">{{ $t('seedBox.12') }}
            </div>
          </div>
          <div class="blex-left items-stretch w-1/3 pr-6 lg:pr-0">
            <div class="text-white font-semiBold text-base lg:text-xl w-full pb-10"
            >
              {{ $t('seedBox.13') }}
            </div>
            <div class="text-gray font-medium text-2xs lg:text-xs leading-xs"
            >
              {{ $t('seedBox.14') }}<br class="hidden lg:block">{{ $t('seedBox.15') }}
            </div>
          </div>
          <div class="blex-left w-1/3 pr-6 lg:pr-0">
            <div class="text-white font-semiBold text-base lg:text-xl w-full pb-10">
              {{ $t('seedBox.22') }}
            </div>
            <div class="text-gray font-medium text-2xs lg:text-xs leading-xs">
              {{ $t('seedBox.23') }}<br class="hidden lg:block"> {{ $t('seedBox.24') }}
            </div>
          </div>
        </div>
        <div class="w-full blex-left items-start py-20 lg:py-40">
          <div class="blex-left items-stretch w-1/3 pr-6 lg:pr-0">
            <div class="text-white font-semiBold text-base lg:text-xl w-full pb-10"
            >
              {{ $t('seedBox.16') }}
            </div>
            <div class="text-gray font-medium text-2xs lg:text-xs leading-xs"
            >
              {{ $t('seedBox.17') }}<br class="hidden lg:block"> {{ $t('seedBox.18') }}
            </div>
          </div>
          <div class="blex-left items-stretch w-1/3 pr-6 lg:pr-0">
            <div class="text-white font-semiBold text-base lg:text-xl w-full pb-10"
            >
              {{ $t('seedBox.19') }}
            </div>
            <div class="text-gray font-medium text-2xs lg:text-xs leading-xs"
            >
              {{ $t('seedBox.20') }}<br class="hidden lg:block"> {{ $t('seedBox.21') }}
            </div>
          </div>
          <div class="blex-left items-stretch w-1/3">
            <div class="text-white font-semiBold text-base lg:text-xl w-full pb-10"
            >
              {{ $t('seedBox.25') }}
            </div>
            <div class="text-gray font-medium text-2xs lg:text-xs leading-xs"
            >
              {{ $t('seedBox.26') }}<br class="hidden lg:block"> {{ $t('seedBox.27') }}
            </div>
          </div>

        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'SeedBox',
  watch: {
    loadedImageCount(val) {
      // if (this.imageCount === val && this.$scrollTrigger) {
      //   this.$scrollTrigger.refresh()
      // }
    }
  },
  data: () => ({
    imageCount: 0,
    loadedImageCount: 0
  }),
  mounted() {
    const images = this.$el.querySelectorAll('img')
    this.imageCount = images.length
    images.forEach(img => {
      if (img.complete) {
        this.loadedImageCount++
      } else {
        img.addEventListener('load', () => this.loadedImageCount++)
      }
    })
  }
}
</script>

<style scoped lang="scss">
section::v-deep {

  .bg-line {
    width: 100%;
  }

  .seed-gradient {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: start;
    height: 100%;
    //top: -100%;
    //left: 50%;
    //transform: translate(-50%, 50%);
    width: 100%;

    @media screen and(max-width: 1024px) {
      top: -6%;
      left: 50%;
      transform: translate(-50%, 7%);
      width: 100%;
    }
  }

  .seed-box {
    width: 100%;
    @media screen and(max-width: 1024px) {
      width: 40px;
    }
  }


}

</style>
